/** */
import { urls } from 'services/_url';
import { apiDelete, apiGet, apiPost, apiPut } from 'services/_http';

/** */
const base_url = `${urls.agents}/v1/blogs`;
const blog_runs_url = `${urls.agents}/v1/blog-runs`;
const agent_url = `${urls.agents}/v1/agent`;

export const create = async (options = {}) => {
  return await apiPost(`${base_url}`, { ...options });
};

export const read = async (options = {}) => {
  return await apiGet(`${base_url}`, { ...options });
};

export const readById = async (id, options = {}) => {
  return await apiGet(`${base_url}/${id}`, { ...options });
};

export const fetchAnalytics = async (options = {}) => {
  return await apiGet(`${base_url}/analytics`, { ...options });
};

export const search = async (keys, keyword, options = {}) => {
  const query_string = options.query_string
    ? `${options.query_string}&keyword=${keyword}`
    : `keyword=${keyword}`;
  return await apiGet(`${base_url}/search/${keys}`, {
    ...options,
    query_string
  });
};

export const update = async (options = {}) => {
  return await apiPut(`${base_url}`, { ...options });
};

export const updateById = async (id, options) => {
  return await apiPut(`${base_url}/${id}`, { ...options });
};

export const updateDraft = async (id, options = {}) => {
  return await apiPut(`${base_url}/${id}`, { ...options });
};

export const deleteOne = async (id, options) => {
  return await apiDelete(`${base_url}/${id}`, { ...options });
};

export const deleteMany = async (options) => {
  return await apiDelete(`${base_url}`, { ...options });
};

export const accept = async (id, options = {}) => {
  return await apiPut(`${base_url}/${id}/approve`, { ...options });
};

export const reject = async (id, options = {}) => {
  return await apiPut(`${base_url}/${id}/reject`, { ...options });
};

export const regenerateImage = async (id, options = {}) => {
  return await apiPut(`${base_url}/${id}/regenerate-image`, { ...options });
};

export const manage = async (id, action, options) => {
  return await apiPut(`${base_url}/${id}/${action}`, { ...options });
};

export const fetchBlogRuns = async (options = {}) => {
  return await apiGet(`${blog_runs_url}`, { ...options });
};

export const fetchBlogRunById = async (id, options = {}) => {
  return await apiGet(`${blog_runs_url}/${id}`, { ...options });
};

export const triggerBlogRun = async (options = {}) => {
  return await apiPost(`${agent_url}/blog/run`, { ...options });
};
